import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import {
  emptyObjectResponseSchema,
  superAdminQueryResponseSchema,
  superAdminRestartFailuresResponseSchema,
} from './common-responses';

export const superAdminExecuteQueryBodyV20260601Schema = z.object({
  query: z.string(),
});

export type SuperAdminExecuteQueryBody = z.infer<
  typeof superAdminExecuteQueryBodyV20260601Schema
>;

export const superAdminRestartFailuresBodyV20260601Schema = z.object({
  timeInterval: z.string(),
  failureType: z.string(),
  orgId: z.string(),
});

export type SuperAdminRestartFailuresBody = z.infer<
  typeof superAdminRestartFailuresBodyV20260601Schema
>;

export const superAdminBillEngineeringHoursBodyV20260601Schema = z.object({
  orgId: z.string(),
  hours: z.number(),
  externalNote: z.string(),
  internalNote: z.string().optional(),
});

export type SuperAdminBillEngineeringHoursBody = z.infer<
  typeof superAdminBillEngineeringHoursBodyV20260601Schema
>;

export class SuperAdminExecuteQueryV20260601Schema
  implements ApiSchemaDefinition
{
  static readonly version = 'super-admin-execute-query-2026-06-01' as const;

  readonly name = SuperAdminExecuteQueryV20260601Schema.version;
  readonly schema = superAdminExecuteQueryBodyV20260601Schema;
  readonly response = superAdminQueryResponseSchema;
}

export class SuperAdminRestartFailuresV20260601Schema
  implements ApiSchemaDefinition
{
  static readonly version = 'super-admin-restart-failures-2026-06-01' as const;

  readonly name = SuperAdminRestartFailuresV20260601Schema.version;
  readonly schema = superAdminRestartFailuresBodyV20260601Schema;
  readonly response = superAdminRestartFailuresResponseSchema;
}

export class SuperAdminBillEngineeringHoursV20260601Schema
  implements ApiSchemaDefinition
{
  static readonly version =
    'super-admin-bill-engineering-hours-2026-06-01' as const;

  readonly name = SuperAdminBillEngineeringHoursV20260601Schema.version;
  readonly schema = superAdminBillEngineeringHoursBodyV20260601Schema;
  readonly response = emptyObjectResponseSchema;
}

export const SUPER_ADMIN_API_SCHEMAS = [
  SuperAdminExecuteQueryV20260601Schema,
  SuperAdminRestartFailuresV20260601Schema,
  SuperAdminBillEngineeringHoursV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
